"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateCapsSchema = exports.CAPS_EVALUATE_BATCH_MAX = void 0;
const zod_1 = require("zod");
// The projected-simulation request: a selection of receivables (bl_order_name
// values) to overlay on the book. It carries an id list, not a write — the
// POST verb mirrors eligibility's `POST /evaluate` for the same reason.
exports.CAPS_EVALUATE_BATCH_MAX = 500;
exports.evaluateCapsSchema = zod_1.z
    .object({
    // The cap applies to the deduplicated array; Zod v3's .max() runs before the
    // transform, so the bound is enforced in superRefine after dedup (the
    // eligibility-batch pattern). Absent/empty ⇒ S = ∅ ⇒ projected == book.
    selectedOrderNos: zod_1.z
        .array(zod_1.z.string().trim().min(1, 'order_no must be a non-empty string'))
        .transform((ids) => Array.from(new Set(ids)))
        .superRefine((ids, ctx) => {
        if (ids.length > exports.CAPS_EVALUATE_BATCH_MAX) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.too_big,
                maximum: exports.CAPS_EVALUATE_BATCH_MAX,
                type: 'array',
                inclusive: true,
                message: `selectedOrderNos must contain at most ${String(exports.CAPS_EVALUATE_BATCH_MAX)} unique ids`,
            });
        }
    })
        .optional(),
})
    // A body carrying asOf, closingDate, or any other unknown key is rejected —
    // the clock and the Closing date are server-fixed, never wire inputs.
    .strict();
//# sourceMappingURL=concentration-caps.js.map